import React from 'react';
import moment from 'moment';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import CheckList from '../common/CheckList';
import PersonTypes from '../common/LookupDropDown';
import ControlledNumericInput from '../common/ControlledNumericInput';

class Attributes extends React.Component {

    handleOnChange = (event) => {
        const { target: { name, value } } = event
        this.person[name] = value;

        this.props.actions.updatePerson(this.person);
    };

    handleActiveChange = (e) => {
        this.person.isActive = e.target.checked;
        this.props.actions.updatePerson(this.person);
    }

    handlePersonTypeChange = (e) => this.props.actions.updatePersonType(Number(e.target.value));

    handleIsActiveOnChange = (event) => {
        this.person.isActive = event.value === 'On';
        this.props.onChange(this.person);
    };

    handleDisciplinesChange = (items, checked, value) => {
        if (checked)
            this.props.actions.addPersonDiscipline(value);
        else
            this.props.actions.removePersonDiscipline(value);
    };

    handleDailyRateChange = (canSave) => {
        canSave === true ? this.props.setMaxRateExceeded(false) : this.props.setMaxRateExceeded(true);
    }

    handleCourtTypesChange = (items, checked, value) => {
    if (checked)
        this.props.actions.addPersonCourtType(value);
    else
        this.props.actions.removePersonCourtType(value);
}

    render() {
        this.person = this.props.person;
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <PersonTypes
                            disablePersonTypeDropdown={true}
                            label='Person Type'
                            name='personTypeId'
                            value={this.person.personTypeId}
                            onChange={this.handlePersonTypeChange}
                            lookups={this.props.personTypes}
                        />
                    </Col>

                    {!this.props.person.isProgramPOC &&
                        <Col>
                            <FormGroup>
                                <ControlledNumericInput
                                    label='Daily Rate'
                                    name='dailyRate'
                                    maxLengthToUse={3}
                                    min='0'
                                    max='999'
                                    numberValue={this.person.dailyRate || ''}
                                    disableSave={this.handleDailyRateChange}
                                    setField={this.props.actions.updateRateField}
                                    isValid={this.props.isValid}
                                />
                            </FormGroup>
                        </Col>
                    }
                </Row>
                {!this.props.person.isProgramPOC &&
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Active Start Date:</Label>
                                <Input
                                    type="date"
                                    max="2999-12-31"
                                    name="activeStartDate"
                                    id="activeStartDate"
                                    value={moment(this.person.activeStartDate).format('YYYY-MM-DD')}
                                    onChange={this.handleOnChange}
                                    placeholder="date placeholder"
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Active End Date:</Label>
                                <Input
                                    type="date"
                                    max="2999-12-31"
                                    name="activeEndDate"
                                    id="activeEndDate"
                                    value={moment(this.person.activeEndDate).format('YYYY-MM-DD')}
                                    onChange={this.handleOnChange}
                                    placeholder="date placeholder"
                                />
                            </FormGroup>
                        </Col>
                        <Col className='d-flex align-items-center'>
                            <FormGroup check className='pt-3'>
                                <Label check>
                                    <Input type="checkbox" id="isActive" onChange={this.handleActiveChange} checked={this.person.isActive} />{' '}
                                Is Active
                                 </Label>
                            </FormGroup>
                        </Col>
                    </Row>
                }
                {!this.props.person.isProgramPOC &&
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Court Type(s):</Label>
                                <CheckList
                                    id='courtTypeChecklist'
                                    items={this.props.courtTypes.map(x => ({ id: x.lookupId, name: x.name, description: x.description }))}
                                    selected={this.person.courtTypes ? this.person.courtTypes.filter(x => x.isActive).map(x => x.courtTypeId) : []}
                                    onChange={this.handleCourtTypesChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                }
                {!this.props.person.isProgramPOC &&
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Discipline(s):</Label>
                                <CheckList
                                    id='disciplineCheckList'
                                    items={this.props.disciplines.map(x => ({ id: x.lookupId, name: x.name }))}
                                    selected={this.person.disciplines ? this.person.disciplines.filter(x => x.isActive).map(x => x.disciplineId) : []}
                                    onChange={this.handleDisciplinesChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                }

                {this.person.personType && this.person.personType.name === 'Board of Directors' &&
                    <Row>
                        <Col>
                            <Label>Committee Assignments:</Label>
                            <CheckList
                                items={this.props.committeeAssignments.map(x => ({ id: x.lookupId, name: x.name }))}
                                selectedItems=
                                {
                                    this.person.committeeAssignments
                                        ? this.person.committeeAssignments
                                            .filter(x => x.isActive)
                                            .map(x => x.committeeAssignmentId)
                                        : []
                                }
                                onAdd={this.props.actions.addPersonCommitteeAssignment}
                                onRemove={this.props.actions.removePersonCommitteeAssignment}
                            />
                        </Col>
                    </Row>
                }
            </React.Fragment >
        );
    }
}

export default Attributes;